import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { MessageService } from "primeng/api";
import { TranslocoService } from "@jsverse/transloco";
import { KryptonStaticsLoaderService } from "./krypton-statics-loader.service";

interface KRPayzen {
  onSubmit?: (callback: (event: PayzenEvent) => void) => void;
  onFormReady?: (callback: () => void) => void;
  renderElements?: () => void;
}

declare global {
  interface Window {
    KR?: KRPayzen;
  }
}

interface PayzenEvent {
  clientAnswer: {
    orderStatus: string;
  };
}

@Component({
  selector: "app-payzen-payment",
  standalone: false,
  templateUrl: "./payzen-payment.component.html",
  styleUrl: "./payzen-payment.component.scss",
})
export class PayzenPaymentComponent implements AfterViewInit, OnInit {
  visible = false;
  loading = false;
  @Output() paymentCompleted = new EventEmitter<boolean>();

  constructor(
    private kryptonService: KryptonStaticsLoaderService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.kryptonService
      .loadStatics()
      .then(() => {
        if (window.KR && window.KR.onSubmit) {
          window.KR.onSubmit((event: PayzenEvent) => {
            this.handlePayzenEvent(event);
          });
        }
      })
      .catch((error) => {
        console.error("Error loading Krypton scripts", error);
      });
  }

  ngAfterViewInit() { }

  handlePayzenEvent(event: PayzenEvent) {
    if (event.clientAnswer.orderStatus === 'PAID') {
      this.messageService.add({
        severity: 'success',
        summary: this.transloco.translate('payment.cardAccepted'),
        detail: this.transloco.translate('payment.verificationCompleted'),
      });
      this.paymentCompleted.emit(true);
      this.visible = false;
      this.cdr.detectChanges();
    }
    else {
      console.error('Error en el pago:', event.clientAnswer);
      this.messageService.add({
        severity: 'error',
        summary: this.transloco.translate('payment.cardError'),
        detail: this.transloco.translate('payment.cardProcessingError'),
      });
      this.paymentCompleted.emit(false);
      this.visible = false;
      this.cdr.detectChanges();
    }
    // if (event.type === 'form-ready') {
    //   this.loading = false;
    //   this.cdr.detectChanges();
    // }
  }

  showPayzenForm(formToken: string) {
    this.visible = true;
    this.loading = true;
    setTimeout(() => {
      const container = document.getElementById("payment-form-container");
      if (!container) return;
      container.innerHTML = "";
      const formDiv = document.createElement("div");
      formDiv.className = "kr-embedded";
      formDiv.setAttribute("kr-form-token", formToken);
      container.appendChild(formDiv);
      setTimeout(() => {
        if (window.KR && window.KR.onFormReady) {
          window.KR.onFormReady(() => {
            this.loading = false;
            this.cdr.detectChanges();
          });
        }
        if (window.KR && window.KR.renderElements) {
          window.KR.renderElements();
        }
      }, 200);
    }, 0);
  }

  onDialogHide() {
    const container = document.getElementById("payment-form-container");
    if (container) container.innerHTML = "";
    this.loading = false;
  }
}
